import { render, staticRenderFns } from "./CopyToBrowse.vue?vue&type=template&id=0fc2d558&scoped=true"
import script from "./CopyToBrowse.vue?vue&type=script&lang=js"
export * from "./CopyToBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc2d558",
  null
  
)

export default component.exports